import { Component, Input, OnInit, TemplateRef, ViewChild, inject, OnDestroy, OnChanges, Renderer2, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Article, ArticleAccessLevelType, ArticleBlock, ArticleElementType, ArticleLanguageType, ArticleTag, CreateArticle } from '../../../models/article';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DOMOutputSpec, Schema, NodeSpec } from 'prosemirror-model';
import { nodes as basicNodes, Editor, Toolbar, nodes, marks } from 'ngx-editor';
import { DomSanitizer } from '@angular/platform-browser';
import { ArticleHighlightModelComponent } from '../article-elements/article-highlight-model/article-highlight-model.component';
import { setBlockType } from 'prosemirror-commands';
import { ArticleService } from '../../../services/article.service';
import { LoaderService } from '../../../services/loader.service';
import { KeyTitleModel } from '../../../models/key-value-model';

@Component({
  selector: 'app-translation-popup',
  templateUrl: './translation-popup.component.html',
  styleUrls: ['./translation-popup.component.scss']
})
export class TranslationPopupComponent implements OnInit, AfterViewInit {
  @ViewChild('translationModal') translationModalTemplate!: TemplateRef<TranslationPopupComponent>;
  articleElementType = ArticleElementType;
  @Input() originalArticleBlockList: ArticleBlock[] = [];
  @Input() articleBlockListData: ArticleBlock[] = [];
  @Input() articleId: number;
  @Input() selectTags: ArticleTag[] = [];
  @Input() selectLevel: ArticleAccessLevelType;
  @Input() selectLanguage: ArticleLanguageType;
  @Input() modalReference: any;
  articleData: any[] = [];
  @ViewChild('articleHighlight', { static: true })
  articleHighlightModelComponent: ArticleHighlightModelComponent;
  modalHeight: number;
  modalWidth: number;
  isTranslate: boolean = true;
  typeSelect: KeyTitleModel;
  language: any[] = [];

  constructor(
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private articleService: ArticleService,
    private loaderService: LoaderService) { }

  ngOnInit() {
    this.adjustModalHeight();
  }

  initializeTranslation = () => {
    this.adjustModalHeight();
    this.language = [
      {
        id: 0,
        title: "English"
      },
      {
        id: 1,
        title: "Indonesian"
      }
    ]
    this.typeSelect = this.language.find(x => x.id != this.selectLanguage);
    this.language = this.language.filter(x => x == this.typeSelect);
    this.articleService.getById(`api/article?id=${this.articleId}`).subscribe((response: Article) => {
      this.articleData = response.articleBlocks.map(item => ({
        ...item,
        isActiveForEdit: true,
        displayHtml: this.selectLanguage == ArticleLanguageType.English ? this.sanitizer.bypassSecurityTrustHtml(item.data) : this.sanitizer.bypassSecurityTrustHtml(item.translatedData),
        data: this.typeSelect.id == ArticleLanguageType.English ? item.data : item.translatedData ?? ""
      }));
    }, (err) => {

    });
  }

  ngAfterViewInit() {
    this.scrollTotop();
  }

  private modalService = inject(NgbModal);
  openCancelTransactionModal(cancelTransactionModal: TemplateRef<any>) {
    const modalRef = this.modalService.open(cancelTransactionModal, {
      windowClass: 'delete-section-modal',
      centered: true,
      size: 'sm',
    });

    modalRef.result.then(
      (result) => {
        if (result) {
          this.modalService.dismissAll();
        }
      },
      (reason) => {
        // Handle modal dismissal or other reasons
      }
    );
  }

  openSaveTransactionModal(saveTransactionModal: TemplateRef<any>) {
    if (this.articleData.some(x => (x.elementId != 1 && x.elementId != 4 && x.elementId != 5 && x.elementId != 11) && (x.data === '' || x.data === ""
      || x.data === "<p class=\"subline-text\"></p>" || x.data === "<p class=\"quote-text\"></p>" || x.data === "<h1></h1>"))) {
      this.toastr.error("Please save all blocks!");
      return;
    }
    const modalRef = this.modalService.open(saveTransactionModal, {
      windowClass: 'delete-section-modal',
      centered: true,
      size: 'sm',
    });

    modalRef.result.then(
      (result) => {
        if (result) {
          this.updateArticle();
        }
        else {
          this.modalService.dismissAll();
        }
      },
      (reason) => {
        // Handle modal dismissal or other reasons
      }
    );
  }

  updateArticle() {
    if (this.typeSelect.id == ArticleLanguageType.Indonesian) {
      this.originalArticleBlockList.forEach((item) => {
        const target = this.articleData.find(x => x.id === item.id);
        if (target && target.elementId == 8) {
          if (!this.isSublineEmpty(target.data)) {
            item.translatedData = target.data;
          }
        }
        else if (target && target.elementId == 10) {
          if (!this.isQuoteEmpty(target.data)) {
            item.translatedData = target.data;
          }
        }
        else if (target && target.elementId == 2) {
          if (!this.isHeaderEmpty(target.data)) {
            item.translatedData = target.data;
          }
        }
        else {
          if (target.data != null && target.data != undefined && target.data != "") {
            item.translatedData = target.data;
          }
        }
      });
    }
    else {
      this.originalArticleBlockList.forEach((item) => {
        const target = this.articleData.find(x => x.id === item.id);
        if (target && target.elementId == 8) {
          if (!this.isSublineEmpty(target.data)) {
            item.data = target.data;
          }
        }
        else if (target && target.elementId == 10) {
          if (!this.isQuoteEmpty(target.data)) {
            item.data = target.data;
          }
        }
        else if (target && target.elementId == 2) {
          if (!this.isHeaderEmpty(target.data)) {
            item.data = target.data;
          }
        }
        else {
          if (target.data != null && target.data != undefined && target.data != "") {
            item.data = target.data;
          }
        }
      });
    }
    let data = {
      id: this.articleId,
      tags: this.selectTags?.map((x) => x.id),
      articleBlocks: this.originalArticleBlockList,
      accessLevel: this.selectLevel
    } as CreateArticle;
    this.loaderService.setLoading(true);

    if (this.articleId) {
      this.articleService.updateArticle(data).subscribe(
        (res: Article) => {
          this.loaderService.setLoading(false);
          if (res) {
            this.toastr.success('Article Updated Successful!');
            this.modalReference.close(true);
          }
        },
        (err) => {
          this.loaderService.setLoading(false);
        }
      );
    }
  }

  updateElement(e: ArticleBlock, index: number) {
    this.articleData[index] = e;
  }

  openHighLightModel(e: any) {
    this.articleHighlightModelComponent.open(e);
  }

  identify(index: number, item: ArticleBlock) {
    return item.elementId;
  }

  isSublineEmpty(html: string): boolean {
    if (!html)
      return true;

    const div = document.createElement('div');
    div.innerHTML = html;

    const p = div.querySelector('p.subline-text');
    if (!p)
      return true;

    return p.textContent?.trim().length === 0;
  }

  isQuoteEmpty(html: string): boolean {
    if (!html)
      return true;

    const div = document.createElement('div');
    div.innerHTML = html;

    const p = div.querySelector('p.quote-text');
    if (!p)
      return true;

    return p.textContent?.trim().length === 0;
  }

  isHeaderEmpty(html: string): boolean {
    if (!html)
      return true;

    const div = document.createElement('div');
    div.innerHTML = html;

    const p = div.querySelector('h1');
    if (!p)
      return true;

    return p.textContent?.trim().length === 0;
  }

  onCloseModal() {
    this.modalReference.close(null);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustModalHeight();
    this.scrollTotop();
  }

  adjustModalHeight() {
    this.modalHeight = window.innerHeight * 0.60;
    this.modalWidth = window.innerWidth * 0.8;
  }

  scrollTotop() {
    let myDiv = document.querySelector('.body-padding');
    if (myDiv != null) {
      myDiv.scrollTop = 0;
    }
  }
}
